<template>
    <b-modal :visible="showAdminModal === 'addEditVirtualNumber'" size="lg" @hidden="hideModal" :lazy="true">
        <div slot="modal-title">
            <h4 class="modal-title" v-if="item">Изменить виртуальный номер {{item.number}}</h4>
            <h4 class="modal-title" v-else>Добавить виртуальный номер</h4>
        </div>
        <loading v-if="loading" :size="3" message="Сохраняем..."></loading>
        <form v-else>
            <div class="form-group row" :class="{ 'has-danger': $v.newDataItem.number.$error }">
                <label for="item-number" class="col-4 col-form-label">Номер телефона</label>
                <div class="col-8">
                    <input class="form-control" type="text" id="item-number" v-model.trim="newDataItem.number" @input="$v.newDataItem.number.$touch()">
                    <span class="small help-block text-danger" v-if="$v.newDataItem.number.$error">Номер телефона обязательн должн быть указан, минимум {{$v.newDataItem.name.$params.minLength.min}} символов, только цифры</span>
                </div>
            </div>
            <div class="form-group row" :class="{ 'has-danger': $v.newDataItem.name.$error }">
                <label for="item-name" class="col-4 col-form-label">Название</label>
                <div class="col-8">
                    <input class="form-control" type="text" id="item-name" v-model.trim="newDataItem.name" @input="$v.newDataItem.name.$touch()">
                    <span class="small help-block text-danger" v-if="$v.newDataItem.name.$error">Название обязательно должно быть указано, минимум {{$v.newDataItem.name.$params.minLength.min}} символа</span>
                </div>
            </div>
            <div class="form-group row">
                <label class="col-4 form-control-label">Город</label>
                <div class="col-8">
                    <multiselect
                            :options="cities"
                            :searchable="true"
                            :close-on-select="true"
                            :show-labels="false"
                            v-model="selected.city"
                            placeholder="Город не выбран"
                            track-by="id" label="name"
                            @input="changeCity"
                    >

                    </multiselect>
                </div>
            </div>
            <div class="form-group row">
                <label for="item-country" class="col-4 col-form-label">Страна</label>
                <div class="col-8">
                    <input class="form-control" type="text" id="item-country" v-model.trim="newDataItem.country">
                </div>
            </div>
            <div class="form-group row">
                <label for="item-site" class="col-4 col-form-label">Сайт</label>
                <div class="col-8">
                    <input class="form-control" type="text" id="item-site" v-model.trim="newDataItem.site">
                </div>
            </div>
        </form>
        <div slot="modal-footer">
            <button v-if="!loading" :class="{ 'disabled': $v.newDataItem.$invalid }" :disabled="$v.newDataItem.$invalid" type="button" class="btn btn-success" @click.prevent="beforeUpdateForm">
                <template v-if="item">Сохранить изменения</template>
                <template v-else>Добавить виртуальный номер</template>
            </button>
        </div>
    </b-modal>
</template>
<script>
  import { required, minLength, numeric } from 'vuelidate/lib/validators'
  import addVirtualNumberMutate from './../../gql/mutations/PBX/AddVirtualNumber.graphql'
  import UpdateVirtualNumberMutate from './../../gql/mutations/PBX/UpdateVirtualNumber.graphql'
  import { mapState, mapActions } from 'vuex'
  import Multiselect from 'vue-multiselect'
  import { ADD_TOAST_MESSAGE } from 'vuex-toast'

  export default {
    computed: {
      ...mapState({
        showAdminModal: state => state.adminStore.showModal,
        item: state => state.adminStore.editVirtualNumber,
        cities: state => state.globalStore.cities
      }),
      color () {
        return {
          hex: this.newDataItem.color
        }
      }
    },
    watch: {
      showAdminModal: function (val) {
        if (val === 'addEditVirtualNumber' && this.item) {
          this.setNewDataItem()
        }
        if (val === 'addEditVirtualNumber' && !this.item) {
          this.clearData()
        }
      }
    },
    data () {
      return {
        loading: false,
        newDataItem: {},
        selected: {
          city: null
        }
      }
    },
    methods: {
      setNewDataItem () {
        const item = this.item
        this.selected = {
          city: item.city
        }
        this.newDataItem = Object.assign({}, item)
        delete this.newDataItem.city
        if (item.city) {
          this.newDataItem.cityId = item.city.id
        }
      },
      beforeUpdateForm () {
        this.$v.newDataItem.$touch()
        if (this.$v.newDataItem.$error) {
          return
        }
        if (this.item) {
          this.updateItem()
        } else {
          this.addItem()
        }
      },
      addItem () {
        this.loading = true
        this.$apollo.mutate({
          mutation: addVirtualNumberMutate,
          variables: this.newDataItem
        }).then((data) => {
          this.loading = false
          this.addToast({
            text: 'Виртуальный номер успешно добавлен',
            type: 'success',
            dismissAfter: 3000
          })
          this.hideModal()
        }).catch((error) => {
          console.error(error)
          this.addToast({
            text: 'Произошла ошибка:' + error,
            type: 'danger',
            dismissAfter: 10000
          })
          this.loading = false
        })
      },
      updateItem () {
        this.loading = true
        this.$apollo.mutate({
          mutation: UpdateVirtualNumberMutate,
          variables: this.newDataItem
        }).then((data) => {
          this.loading = false
          this.addToast({
            text: 'Виртуальный успешно обновлен',
            type: 'success',
            dismissAfter: 3000
          })
          this.hideModal()
        }).catch((error) => {
          console.error(error)
          this.addToast({
            text: 'Произошла ошибка:' + error,
            type: 'danger',
            dismissAfter: 10000
          })
          this.loading = false
        })
      },
      hideModal () {
        this.clearData()
        this.$store.commit('SET_ADMIN_EDIT_VIRTUAL_NUMBER', null)
        this.$store.dispatch('setAdminModal', false)
      },
      ...mapActions({
        addToast: ADD_TOAST_MESSAGE
      }),
      clearData () {
        this.newDataItem = {
          id: null,
          name: '',
          number: '',
          country: '',
          site: '',
          cityId: null
        }
        this.$v.newDataItem.$reset()
        this.selected = {
          city: null
        }
      },
      changeCity (city) {
        if (city) {
          this.newDataItem.cityId = city.id
        } else {
          this.newDataItem.cityId = null
        }
      }
    },
    components: {
      Multiselect
    },
    validations: {
      newDataItem: {
        name: {
          required,
          minLength: minLength(2)
        },
        number: {
          required,
          numeric,
          minLength: minLength(7)
        },
        site: {
          required
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// ModalAdminAddEditVirtualNumber.vue?68fcd208